export default __webpack_public_path__ + "static/media/Affrescati_dettagli_struttura_01.4aee18a2.jpg";